export default [{
	titulo: 'Artístico e Literário',
	icone: 'menu-icon fa fa-caret-right',
	url: '/links/artistico-literario',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]